document.addEventListener('click', (event) => {
    const button = event.target.closest('.blocks__text-section__foldout-button');
    if (button) {
        const content = button.nextElementSibling;
        if (content && content.classList.contains('blocks__text-section__content')) {
            content.classList.toggle('visible');
            button.classList.toggle('active');
        }
    }
});